import { theme } from 'antd';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectCategories } from 'reduxStore/categories/selectors';
import CategoryDrawer from 'zComponents/molecules/CategoryDrawer';
import { Button, Col, Empty, Flex, Row, Typography } from 'zui/Antd';

const { Text } = Typography;

function RenderCategoriesPanelContent({ searchResults = [], isSearching = false }) {
	const {
		token: {
			colorTextLabel,
			fontWeightStrong,
			padding,
			borderRadius,
			paddingSM,
			colorFill,
			colorPrimaryText,
			lineHeight,
			lineHeightLG,
			fontSizeLG
		}
	} = theme.useToken();

	const [selectedCategory, setSelectedCategory] = useState(null);
	const [openDrawer, setOpenDrawer] = useState(false);

	const allCategoriesData = useSelector(selectCategories);
	const displayData = isSearching ? searchResults.map((result) => result.item) : allCategoriesData;

	if (displayData.length === 0) {
		return (
			<Flex align='center' justify='center' vertical style={{ width: '100%', padding }}>
				<Empty description={isSearching ? 'No search results found' : 'No categories to display'} />
			</Flex>
		);
	}

	return (
		<Row gutter={[20, 20]} justify='start'>
			{displayData.map((category, index) => (
				<Col key={isSearching ? `search-${index}` : index} xl={8} lg={12} sm={24}>
					<Flex
						vertical
						style={{
							border: `1px solid ${colorFill}`,
							padding: paddingSM,
							borderRadius,
							boxSizing: 'border-box'
						}}
					>
						<Flex align='center' justify='space-between'>
							<Flex vertical flex={1} style={{ width: 0 }}>
								<Text
									ellipsis={{ tooltip: category?.name }}
									style={{
										width: '100%',
										color: colorTextLabel,
										fontWeight: fontWeightStrong,
										fontSize: fontSizeLG,
										lineHeight: lineHeightLG
									}}
								>
									{category?.name || '--'}
								</Text>
								<Text
									ellipsis={{ tooltip: `Type: ${category?.typeName || '-'}` }}
									style={{
										width: '100%',
										color: colorTextLabel,
										fontWeight: 500,
										lineHeight: lineHeight
									}}
								>
									Type: {category?.typeName || '--'}
								</Text>
							</Flex>

							<Button
								onClick={() => {
									setSelectedCategory(category?.categoryID);
									setOpenDrawer(true);
								}}
								type='text'
								style={{ color: colorPrimaryText }}
							>
								View Categories
							</Button>
						</Flex>
					</Flex>
				</Col>
			))}
			<CategoryDrawer categoryID={selectedCategory} visible={openDrawer} setVisible={setOpenDrawer} />
		</Row>
	);
}

export default RenderCategoriesPanelContent;
